import angular from 'angular';
import _ from 'underscore';

export default class OfferMatchingCriteria {
  constructor($scope, OfferService, UserProductService) {
    $scope.search_items = function() {
      if (!$scope.filter.buyer_id) {
        alert('Please select a buyer first!');
        return false;
      }
      $scope.filter.buyer_user_products = _.pluck(_.where($scope.buyer_user_products, {
        checked: true
      }), 'id');
      $scope.filter.personal_search_mode = 1;
      $scope.searching_match = true;
      $scope.tabs[0].offers = [];
      $scope.tabs[0].items = [];
      $scope.tabs[0].filter.offer_id = null;
      OfferService.get_buyer_matched_items($scope.filter).then(function(response) {
        $scope.tabs[0].offers = [{
          id: window.offer.id,
          title: window.offer.titleEN + ' (' + window.offer.id + ')'
        }];
        $scope.tabs[0].items = response.data.items;
        $scope.set_tab_properties(0);
        $scope.searching_match = false;
      });
    };

    $scope.set_filters = function() {
      $scope.filter.min_quality_accuracy = 1;
      $scope.filter.min_specs_accuracy = 1;
      $scope.filter.specs_method_standard = true;
      $scope.filter.specs_method_relative = false;
      $scope.filter.specs_method_special = false;
      $scope.filter.specs_method_advanced = false;
      $scope.filter.specs_matching_accurate = true;
      $scope.filter.specs_matching_flexible = true;
      $scope.filter.specs_matching_basic_only = false;
      $scope.filter.buyer_user_products = [];
    };

    $scope.load_buyer_user_products = function(buyer_id) {
      UserProductService.get_user_products(buyer_id).then(function(data) {
        _.each(data.user_products, function(user_product) {
          if (user_product.product) {
            $scope.buyer_user_products.push({
              id: user_product.id,
              title: user_product.product.title,
              checked: _.contains($scope.filter.buyer_user_products, user_product.id)
            });
          }
        });
      });
    };

    $scope.update_criteria = function() {
      $scope.updating_criteria = true;
      $scope.filter.buyer_user_products = _.pluck(_.where($scope.buyer_user_products, {
        checked: true
      }), 'id');
      OfferService.update_create_filters($scope.filter).then(function(data) {
        if (data.success)
          $scope.updating_criteria = false;
      });
    };

    $scope.init = function() {
      $scope.manage_criteria = window.manage_criteria;
      if (window.manage_criteria && window.offer.create_filters)
        angular.extend($scope.filter, window.offer.create_filters.filters);
      else
        $scope.set_filters();
      if (window.offer.parent_offer_id && window.offer.buyer_id) {
        $scope.buyer_user_products = [];
        $scope.load_buyer_user_products(window.offer.buyer_id);
      }
    };

    $scope.init();
  }
}

OfferMatchingCriteria.$inject = ['$scope', 'OfferService', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-matching-criteria.ctrl.js